import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import * as passwordValidator from 'password-validator';
import {preparePasswordValid} from "../../common/common";

@Component({
  templateUrl: "./change-password-dialog.component.html",
  selector: "change-password-dialog",
  // styleUrls: ["./error.component.css"]
  providers: [BsModalService]
})


export class ChangePasswordDialogComponent implements OnDestroy{

    @Input() data: any = {};
    @Output() action = new EventEmitter();
    buttonAction = false;
    public newPass1: string ='';
    public newPass2: string ='';
    private schema = new passwordValidator();
    public isValidPass= false;

  constructor(public bsModalRef: BsModalRef) {
      this.buttonAction = false;

      this.schema = preparePasswordValid();

      // this.schema.is().min(6)                                    // Minimum length 6
      //     .is().max(12)                                  // Maximum length 12
      //     .has().uppercase()                              // Must have uppercase letters
      //     .has().lowercase()                              // Must have lowercase letters
      //     .has().digits()                                 // Must have digits
      //     .has().not().spaces()                           // Should not have spaces
      //     .is().not().oneOf(['Passw0rd', 'Password123']); // Blacklist these values
  }

  ngOnDestroy(){
      if (!this.buttonAction){
        this.action.emit({valid:false});
      }
  }
  clickOk() {
    // console.log("Click ok...");
      this.newPass1 = this.newPass1.trim();
    if (this.verPass()) {
        this.buttonAction = true;
        this.action.emit({valid:true, pass:this.newPass1});
        this.bsModalRef.hide();

    }
  }

  verPass() {
      this.isValidPass = this.schema.validate(this.newPass1) ;
      return this.isValidPass;
  }

  cancel() {
    this.buttonAction = true;
    this.bsModalRef.hide();
    this.action.emit({valid:false});
  }
}
